import { render, staticRenderFns } from "./expertList.vue?vue&type=template&id=a7d483bc"
import script from "./expertList.vue?vue&type=script&lang=js"
export * from "./expertList.vue?vue&type=script&lang=js"
import style0 from "./expertList.vue?vue&type=style&index=0&id=a7d483bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports